<template>
  <div class="form-body col-md-8 col-sm-12">
    <v-row class="form-item-section personal-info-section">
      <v-row class="personal-info-row p-b-15" v-slimscroll>
        <v-col cols="12" sm="12" md="12" class="heading">
          <h3>PERSONAL INFORMATION COLLECTION STATEMENT</h3>
          <ol>
            <li>It is often necessary for our current or prospective individual clients, or, where our clients are corporate or business entities, their individual representatives and employees (collectively referred to as "clients" and otherwise referred to as "client", "you" or "your") to provide to Marsh (Singapore) Pte Ltd (hereinafter referred to as "MARSH", "we", "our" or "us", and references to Marsh include the appropriate Marsh Affiliate(s)) personally id entifiable data about yourselves ("Personal Information") in connection with our business process execution, including delivery of services and/or products, preparation of proposals, provision of quotations, arranging insurance cover, managing claims, client relationship management and conducting internal conflicts checks. Such Personal Information may include information or data provided by you or other parties or from other source, and may include, but is not limited to, historical or existing data and/or data to be collected in the future. Such Personal Information may be subject to applicable data protection, privacy and other similar laws and may include copies and other details of identity documents, proof of address and other contact details, information concerning age, commission or alleged commission of any offence or proceedings for any offence committed or alleged to have been committed, the disposal of such proceedings or the sentence of any court in such proceedings.
              <br/>
              <br/>
              When you provide MARSH with Personal Information relating to your employees, dependents and/or other individuals that you represent, you will observe the provisions of any data protection or privacy legislation as applicable from time to time the extent applicable to this Agreement. This includes, without limitation: (i) an obligation, if any, for you to obtain any required consent(s) in respect of the transfer of information to MARSH by the provider or any third party relating to an identified or identifiable individual that is subject to applicable data protection, privacy or other similar laws and (ii) any obligation with respect to the use, disclosure and transfer by MARSH of personal information as necessary to carry out its obligations under this Agreement.
            </li>
            <li>Personal Information you provide will be collected, used and otherwise processed by MARSH for the following purposes:
              <ol>
                <li>client relationship management procedures, including any potential conflict checks as may be required;</li>
                <li>the delivery of services or products to the client;</li>
                <li>those purposes specifically provided for in any particular service or product offered by MARSH;</li>
                <li>credit assessments and other background checks of the client as MARSH may determine to be necessary or appropriate;</li>
                <li>MARSH’s internal record-keeping;</li>
                <li>collection of outstanding payments from clients;</li>
                <li>prevention of crime (including but not limited to fraud, money-laundering, bribery); and</li>
                <li>meeting any legal or regulatory requirements relating to MARSH's provision of services and products and to make disclosure under the requirements of any applicable law, regulation, direction, court order, by-law, guideline, circular, code applicable to MARSH or its Affiliates.</li>
              </ol>
            </li>
            <li>MARSH may provide or disclose this Personal Information to its Affiliates for the purposes stated in paragraph 2 above.</li>
            <h3>Collection and Disclosure</h3>
            <li>
              MARSH may provide or disclose this Personal Information to its Affiliates for the purposes stated in paragraph 2 above.
              <ol>
                <li>any person to whom MARSH is compelled or required to do so under law or in response to a competent or government agency;</li>
                <li>other relevant parties arranging insurance or providing claims services or benefits administration services or wellness services such as insurance companies, health maintenance organizations, agents and service providers (including but not limited to consultants, market research and quality assurance companies);</li>
                <li>Marsh’s Affiliates;</li>
                <li>government agencies and industry regulators;</li>
                <li>MARSH’s auditors, accountants, lawyers or other financial or professional advisers; </li>
                <li>such sub-contractors or third party service or product providers as MARSH may determine to be necessary or appropriate, in accordance with paragraph 2 and paragraph 7; and</li>
                <li>such person(s) as you may instruct or require.</li>
              </ol>
            </li>
            <li>
              Failure to provide such Personal information may result in MARSH being unable to provide clients and you with the services and/or products requested.
            </li>
            <h3>
              Safeguards
            </h3>
            <li>
              MARSH confirms that MARSH has implemented the appropriate administrative and security safeguards and procedures in accordance with the applicable laws and regulations to prevent the unauthorized or unlawful processing of your Personal Information and the accidental loss or destruction of, or damage to, your Personal Information.
            </li>
            <h3>
              Data Transfer
            </h3>
            <li>
              Where MARSH considers it necessary or appropriate for the purposes of data storage or processing or providing any service or product on our behalf to you, we may transfer your Personal Information to an Affiliate or third party service or product providers within or outside the country in which MARSH is established, under conditions of confidentiality and similar levels of security safeguards.
            </li>
            <h3>
              Your Rights of Access and Correction
            </h3>
            <li>
              You have the right to request access to and correction of information about you held by MARSH and you may:
              <ol>
                <li>
                  request that MARSH correct any of your Personal Information that is inaccurate, incomplete or out-of-date;
                </li>
                <li>
                  request that MARSH specify or explain its policies and procedures in relation to data and types of Personal Information handled by MARSH;
                </li>
                <li>
                  communicate to MARSH your objection to the use of your Personal Information for marketing purposes whereupon MARSH will not use your Personal Information for these purposes; and
                </li>
                <li>
                  withdraw, in full or in part, your consent given previously,
                </li>
              </ol>
            </li>
            <li>
              Written requests for access to Personal Information or correction and/or deletion of Personal Information or for information regarding policies and procedures and types of Personal Information handled by MARSH may be sent to <a href="mailto:privacycoordinator@marsh.com">privacycoordinator@marsh.com.</a>
            </li>
          </ol>
        </v-col>
      </v-row>
    </v-row>
    <v-col
        cols="12"
        class="button-container col-12"
        v-if="!$store.state.isEditMode"
    >

      <v-btn
          class="ma-2 form-button continue right"
          dark
          color="#0080B4"
          @click="goHome"
      >
        <span class="home-icon"></span>
        Return Home
      </v-btn>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "PersonalInfoCollectionStatement-hk",
  data() {
    return {
      valid: false
    };
  },
  methods: {
    goHome: function() {
      this.$store.state.formPageNumber=0;
    }

  }
}
</script>

<style scoped>

</style>
